export default {"src":"/_next/static/media/button-DeepLink-W.45cfb7c4.svg","height":52,"width":170,"blurWidth":0,"blurHeight":0};